import * as punycode from 'punycode'
import { setHours, setMinutes, startOfDay } from 'date-fns'
import { IEventData } from '../request/response'
import { toColor } from '../../../utils/ColorTransformator'
import { dateWithoutOffsert } from '../../License/mappers/mapResponseToLicense'
import { EventStatus, IEvent, IGuestInfo } from '..'

export default function(item: IEventData): IEvent {
  const finishDate = startOfDay(
    dateWithoutOffsert(new Date(Number(item.end_time) * 1000)),
  )

  const startDate = startOfDay(
    dateWithoutOffsert(new Date(Number(item.start_time) * 1000)),
  )

  const createdAt = new Date(Number(item.create_date) * 1000)
  const modifiedAt = new Date(Number(item.modify_date) * 1000)

  const arrivalTime = item.arrival_time
    ? setMinutes(
        setHours(startDate, Number(item.arrival_time.split(':')[0])),
        Number(item.arrival_time.split(':')[1]),
      )
    : ''
  const departureTime = item.departure_time
    ? setMinutes(
        setHours(finishDate, Number(item.departure_time.split(':')[0])),
        Number(item.departure_time.split(':')[1]),
      )
    : ''

  let kidsAge = null
  try {
    kidsAge =
      item.kids_age && item.kids_age !== 'Array'
        ? JSON.parse(item.kids_age)
        : ''
  } catch (e) {
    console.error(e)
  }

  return {
    _bookingPrice: item.booking_price,
    _deposit: item.stay_deposit,
    _localTax: item.local_tax,
    _price: item.price,
    _pricePerDay: item.price_for_night,
    _provision: item.provision,
    additionalServices: item.additional_services,
    adults: Number(item.persons),
    arrivalTime,
    bookingId: item.booking_id_reservation,
    airbnbId: item.airbnb_id_reservation,
    get bookingPrice() {
      return this._bookingPrice
    },
    company: item.company !== null && {
      city: item.company.city,
      country: item.company.country,
      name: item.company.company_name,
      postCode: item.company.post_code,
      street: item.company.street,
      vatId: item.company.vat_number,
    },
    createdAt,
    customColor:
      item.custom_color && item.custom_color !== '#0'
        ? toColor(item.custom_color)
        : null,
    dateToPay:
      item.date_to_pay && item.date_to_pay !== '0'
        ? dateWithoutOffsert(new Date(Number(item.date_to_pay) * 1000))
        : undefined,
    dateToPayAfterStart:
      item.date_to_pay_after_start && item.date_to_pay_after_start !== '0'
        ? dateWithoutOffsert(
            new Date(Number(item.date_to_pay_after_start) * 1000),
          )
        : undefined,
    departureTime,
    get deposit() {
      return this._deposit
    },
    doorCode: item.room_key_code,
    doubleBed: item.doubleBed,
    finishDate,
    guest: {
      apartmentNumber: item.local_number,
      city: item.city,
      country: item.nationality,
      email: punycode.toUnicode(item.client_email),
      houseNumber: item.street_number,
      idCard: item.id_card,
      name: item.client_name,
      passport: item.passport,
      phone: item.client_phone,
      postCode: item.post_code,
      street: item.street,
    },
    iCalendarId:
      String(item.icalendar_import) === '1'
        ? item.icalendar_id_reservation
        : null,
    id: item.id,
    isDeleted: item.deleted === '1',
    kids: Number(item.kids),

    kidsAge,
    get localTax() {
      return this._localTax
    },

    localTaxIncluded: item.local_tax_included
      ? item.local_tax_included === '1'
        ? true
        : false
      : undefined,
    modifiedAt,
    notes: item.description,
    get paymentOnPlace() {
      return String(this._price - this._provision)
    },
    paymentOnPlaceDate:
      item.payment_on_place_date && item.payment_on_place_date !== '0'
        ? dateWithoutOffsert(
            new Date(Number(item.payment_on_place_date) * 1000),
          )
        : undefined,

    paymentOnPlaceMethod: item.payment_on_place_method,
    prepaidType: item.prepayment_type,
    get price() {
      return this._price
    },
    get pricePerDay() {
      return this._pricePerDay
    },
    priceType: item.price_type ? Number(item.price_type) : 0,
    provenance: item.provenance,
    get provision() {
      return this._provision
    },

    provisionDate:
      item.provision_date && item.provision_date !== '0'
        ? dateWithoutOffsert(new Date(Number(item.provision_date) * 1000))
        : undefined,
    provisionMethod: item.provision_payment_method,
    registration: item.registration,
    roomId: item.id_room,
    roomMates: item.roommates
      ? ((item.roommates as unknown) as IGuestInfo[])
      : undefined,
    service: item.service,
    singleBed: item.singleBed,
    stage: item.stage.toString() !== '0' ? item.stage : EventStatus.NoPayment,
    startDate,
    from_website: item.from_website,
  }
}
